"use strict";
import angular from "angular";

const diasSichtbarkeit = angular.module("dias.sichtbarkeit", [
]);

export default diasSichtbarkeit;
